  document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".ma-tab-link");
    const panes = document.querySelectorAll(".ma-tab-pane");

    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        // Remove active classes
        tabs.forEach(t => t.classList.remove("active"));
        panes.forEach(p => p.classList.remove("active"));

        // Add active class to selected
        tab.classList.add("active");
        document.getElementById(tab.dataset.tab).classList.add("active");
      });
    });
  });
  document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".responsive-banner", {
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const content = document.querySelector(".article-content"); // Adjust selector
  const tableRow = document.querySelector(".af-table-row");

  // ✅ Exit safely if elements don’t exist
  if (!content || !tableRow) {
    console.warn("article-content or af-table-row not found.");
    return;
  }

  const headings = content.querySelectorAll("h2, h3");
  if (!headings.length) {
    console.warn("No h2 or h3 found inside article-content.");
    return;
  }

  let h2Counter = 0;
  let h3Counter = 0;

  headings.forEach((heading, index) => {
    const tagName = heading.tagName.toLowerCase();

    const div = document.createElement("div");
    div.classList.add("af-table-col");

    const innerDiv = document.createElement("div");
    innerDiv.classList.add("af-table-text");
    innerDiv.setAttribute("data-heading-level", tagName);

    const span = document.createElement("span");
    span.classList.add("af-table-num");

    if (tagName === "h2") {
      h2Counter++;
      h3Counter = 0;
      span.textContent = `${h2Counter}.`;
    } else if (tagName === "h3") {
      h3Counter++;
      span.textContent = `${h2Counter}.${h3Counter}`;
    }

    const link = document.createElement("a");
    link.classList.add("scrollable-link");
    link.href = `#heading-${index}`;
    link.textContent = heading.textContent;

    innerDiv.appendChild(span);
    innerDiv.appendChild(link);
    div.appendChild(innerDiv);
    tableRow.appendChild(div);

    heading.id = `heading-${index}`;
  });
});

















 
document.addEventListener("DOMContentLoaded", function () {
  // Attach the function to the "forgot password" button click
  const forgetBtn = document.querySelector(".forget-password");
  if (forgetBtn) {
    forgetBtn.addEventListener("click", function () {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 1000);
    });
  }

  // Open description tab by default
  const descTab = document.querySelector("#tab-description-mobile");
  const reviewsTab = document.querySelector("#tab-customer-reviews-mobile");
  if (descTab) descTab.style.display = "block";
  if (reviewsTab) reviewsTab.style.display = "block";

  // smile.io button z-index change after delay
  setTimeout(() => {
    const smileContainer = document.querySelector("#smile-ui-container");
    if (smileContainer) smileContainer.style.zIndex = "30";
  }, 5000);

  // Empty input on clear button click
  window.clearInput = function () {
    const birthdayInput = document.getElementById("birthday");
    if (birthdayInput) {
      birthdayInput.setCustomValidity("");
      birthdayInput.value = "";
    }
  };

  // Show/hide password fields
  const passwordWrappers = document.querySelectorAll(".af-show-hide_pass");
  passwordWrappers.forEach((wrapper, index) => {
    const inputField = wrapper.querySelector("input");
    const eyeIcon = wrapper.querySelector(".af-eye-show_pass");
    const eyeCloseIcon = wrapper.querySelector(".af-eye_close");
    const eyeOpenIcon = wrapper.querySelector(".af-eye_open");

    if (!inputField || !eyeIcon) return;

    let isPasswordVisible = false;

    eyeIcon.addEventListener("click", () => {
      if (isPasswordVisible) {
        inputField.type = "password";
        isPasswordVisible = false;
        if (eyeCloseIcon) eyeCloseIcon.style.display = "none";
        if (eyeOpenIcon) eyeOpenIcon.style.display = "block";
      } else {
        inputField.type = "text";
        isPasswordVisible = true;
        if (eyeCloseIcon) eyeCloseIcon.style.display = "block";
        if (eyeOpenIcon) eyeOpenIcon.style.display = "none";
      }
    });
  });

  // Validation for birthday field on register account page
  window.validateBirthday = function () {
    const birthdayInput = document.getElementById("birthday");
    const errorElement = document.getElementById("errorElement");
    const regex = /^(0[1-9]|1\d|2\d|3[01])-(0[1-9]|1[0-2])-\d{4}$/;

    if (birthdayInput && !regex.test(birthdayInput.value)) {
      birthdayInput.setCustomValidity('Please enter your birthday in the format "dd-mm-yyyy".');
      if (errorElement) errorElement.textContent = 'Please enter your birthday in the format "dd-mm-yyyy".';
    } else if (birthdayInput) {
      birthdayInput.setCustomValidity("");
      if (errorElement) errorElement.textContent = "";
    }
  };
});
